module.exports = __webpack_public_path__ + "static/media/apple.dc2e9786.png";